import { useEffect, useRef, useState } from 'react';
import { initControls, resize_map, ControlsMap } from "Components/Atoms/A_Reusable/ControlsMap";
import RenderMap from 'Components/Organisms/O_Reusable/RenderMap';
import VListLevels from "Components/Organisms/O_VViewer/VListLevels"
import { VListEvents } from "Components/Organisms/O_VViewer/VListEvents";
import { VolcanosMap } from "Components/Organisms/O_VViewer/VolcanosMap";
import { InfoObservatory } from "Components/Organisms/O_VViewer/InfoObservatory";
import MapSettingsPanelVolcano from "Components/Organisms/O_VViewer/MapSettingsPanelVolcano";
import LoaderEvents from "Components/Organisms/O_EQViewer/LoaderEvents";
import EQViewerFooter from "Components/Templates/T_EQViewer/EQViewerFooter";
import Notifications from "Components/Organisms/O_Reusable/Notifications";
import { useSelector } from 'react-redux';
import { FilterVolcanos } from 'Components/Molecules/M_VViewer/FilterVolcanos';
import { buildLevel1, buildLevel2, buildLevel3, buildLevel4, filterByLatC, filterByLatN, filterByLatS, removeAccents } from 'Components/Atoms/A_Reusable/filterEvents';
import NoResultsMessage from 'Components/Atoms/A_Reusable/NoResultsMessage';

function VViewer() {

   const volcanos = useSelector( state => state.volcanos );
   const network_filters = useSelector( state => state.network_filters );

	const { modes, list_selected, map_selected } = ControlsMap(720);
	const [order, setOrder] = useState(10);
	const eventRef = useRef();
	const volcanoItems = useRef([]);
	const [volcanoCount, setVolcanoCount] = useState(0);
	const [startEvents, setStartEvents] = useState(false);
	const [filterEvent, setFilter] = useState("");
	const [volcanoSelected, selectVolcano] = useState();
	const orderRef = useRef(10);
	const txtRef = useRef("");

	const setShownItems = ( filterValue = null ) => {
		filterValue = filterValue?.toLowerCase() || txtRef.current;
		volcanoItems.current = volcanos
			.filter(({ properties }) => removeAccents(
				properties.VolcanoName.toLowerCase()
			).includes( removeAccents( filterValue ) ));
		setVolcanoCount(volcanoItems.current.length);
		switch (orderRef.current) {
			case 10:
				volcanoItems.current = volcanoItems.current.sort((a, b) =>
					("" + a.properties.VolcanoName).localeCompare(
						b.properties.VolcanoName
					)
				);
				setFilter("VolcanoName");
				break;
			case 20:
				volcanoItems.current = [
					...buildLevel1( volcanoItems.current ),
					...buildLevel2( volcanoItems.current ),
					...buildLevel3( volcanoItems.current ),
					...buildLevel4( volcanoItems.current )
				]
				setFilter("activityLevel");
				break;
			case 30:
				volcanoItems.current = filterByLatN( volcanoItems.current );
				setFilter("LatN");
				break;
			case 40:
				volcanoItems.current = filterByLatC( volcanoItems.current );
				setFilter("LatC");
				break;
			case 50:
				volcanoItems.current = filterByLatS( volcanoItems.current );
				setFilter("LatS");
				break;
			default: break;
		}
	}

	const handleOrder = ({ target }) => {
		orderRef.current = target.value;
      if ( orderRef.current > 20 ) selectVolcano(null);
		setOrder( orderRef.current );
	};

	const handleFilter = ( value ) => {
		txtRef.current = value;
		setShownItems( value );
		setStartEvents( true );
	}

	const NotFound = () => startEvents ? <NoResultsMessage map /> : <></>

	useEffect(() => {

		initControls("view-modes");
		resize_map();
		eventRef.current = window.addEventListener('resize', resize_map);
		document.title = "SGC - Visor Volcanes";
		return () => {
			eventRef.current && window.removeEventListener(
				'resize', eventRef.current
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setShownItems();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ order, volcanos ])

	return (
		<RenderMap
			event_list={
				<div className="volcanos-list" id="volcanos-list">

					<div className="volcanos-list-filter">
						<div className="volcanos-list-filter-container">
							<div className="volcanos-list-filter-title">
								<h3>Volcanes de Colombia</h3>
							</div>
							<FilterVolcanos
								handleFilter = { handleFilter }
								handleOrder = { handleOrder }
								orderEvent = { orderRef.current }
								txtFilter = { txtRef.current }
								filterEvent = { filterEvent }
							/>
						</div>
					</div>
					<div
						id="events-container"
						className="volcanos-list-main"
					>
						<div className="events-container">
							{
								volcanoItems.current[0]
									? <VListEvents
										volcanoItems={volcanoItems.current}
										selectVolcano={selectVolcano}
										volcanoSelected={volcanoSelected}
									/>
									: <NotFound />
							}
						</div>
					</div>
					<div className="volcanos-list-levels">
						<VListLevels />
					</div>
				</div>
			}
			map={
				<VolcanosMap
					volcanoItems={volcanoItems.current}
					volcanoCount={volcanoCount}
					volcanoSelected={volcanoSelected}
					selectVolcano={selectVolcano}
					network_filters={network_filters}
				/>
			}
			settings={
				<div className="settings_content">
					<InfoObservatory />
					<MapSettingsPanelVolcano />
				</div>
			}
			notificationsPanel={
				<Notifications />
			}
			footer={
				<>
					<LoaderEvents />
					<EQViewerFooter />
				</>
			}
			modes={modes}
			list_selected={list_selected}
			map_selected={map_selected}
		/>
	)
}

export default VViewer;